// extracted by mini-css-extract-plugin
module.exports = {"postCreatePage":"CWI7Q"};